import { createAsyncThunk } from '@reduxjs/toolkit';

import { log } from '../../../services/logging';
import { getAllScenes } from '../../../services/scene';
import type { Scene } from '../../../types/scene';
import { getUserId, getUserRoles, isPerspectiveSharingAvailable } from '../../connections/connectionsDuck';
import { getPerspective } from '../../perspectives/perspectives.selector';
import { isSharedStorageAvailable, sharedStorageApi } from '../../shared-storage/shared-storage.api';
import type { RootState } from '../../types';
import { getScenes } from '../scene.selectors';
import { NAME } from './const';

export const fetchScenesThunk = createAsyncThunk<Scene[], void, { state: RootState }>(
  `${NAME}/fetchScenesThunk`,
  async (_, { dispatch, getState }) => {
    const state = getState();

    const perspective = getPerspective(state);
    if (!perspective) {
      throw Error('Perspective not found');
    }

    const userId = getUserId(state);
    if (!userId) {
      throw Error('User ID not found');
    }

    const isPluginPresent = isPerspectiveSharingAvailable(state);
    let scenes: Scene[] = [];
    try {
      if (isPluginPresent) {
        const userRoles = getUserRoles(state) ?? [];
        scenes = (await getAllScenes(perspective.id, userId, userRoles)) ?? [];
      } else if (isSharedStorageAvailable()) {
        scenes = await dispatch(sharedStorageApi.endpoints.getScenes.initiate(perspective.id)).unwrap();
      }
      const stateScenes = getScenes(state);
      const temporaryScenes = stateScenes.filter(
        (s) =>
          s.temporaryData !== undefined && s.temporaryData?.perspectiveId === perspective.id && s.createdBy === userId,
      );
      return [...scenes, ...temporaryScenes];
    } catch (error) {
      log.error(error);
    }
    return [];
  },
);
